import React from "react"
import { Image as BuilderImage } from '@builder.io/react';

import { FontAwesomeIcon } from "../libs/fonts"
import Layout from "../layout/Layout"
import SectionHeading from '../components/SectionHeading/SectionHeading';
// import { Seo } from "../components/seo"

const Sponsor = ({ pageContext }) => {
  const { data: sponsor } = pageContext;

  return (
    <Layout>
      <div className="rs-about style1 pt-120 pb-120 md-pt-80 md-pb-75">
        <div className="container">
          <div className="row y-middle">
            <div className="col-lg-12 pl-45 md-pl-15">
              <SectionHeading subText={`${sponsor.level} Sponsor`} title={sponsor.name} borderLine />
              <div
                className='pt-40'
                style={{ width: '100%', maxWidth: '350px', minHeight: '100px' }}
              >
                <BuilderImage
                  src={sponsor.logo}
                  alt={`${sponsor.name} logo`}
                />
              </div>

              {sponsor.companyBlurb && sponsor.companyBlurb !== '<p><br></p>' && (
                <p
                  className='inner-html margin-0 mt-60 pt-0 pb-0'
                  dangerouslySetInnerHTML={{ __html: sponsor.companyBlurb }}
                />
              )}

              <ul className='social-icons mt-40' style={{ display: 'flex' }}>
                {sponsor.linkedIn && (
                  <li className='mr-20'>
                    <a href={sponsor.linkedIn} target='_blank' rel='noreferrer'>
                      <FontAwesomeIcon
                        icon={'fa-brands fa-linkedin'}
                        style={{ fontSize: 22, color: 'black' }}
                      />
                      <span style={{ display: 'none' }}>LinkedIn link</span>
                    </a>
                  </li>
                )}
                {sponsor.twitter && (
                  <li className='mr-20'>
                    <a href={sponsor.twitter} target='_blank' rel='noreferrer'>
                      <FontAwesomeIcon
                        icon={'fa-brands fa-x-twitter'}
                        style={{ fontSize: 22, color: 'black' }}
                      />
                      <span style={{ display: 'none' }}>X link</span>
                    </a>
                  </li>
                )}
                {sponsor.mastodon && (
                  <li className='mr-20'>
                    <a href={`https://mastodon.social/${sponsor.mastodon}`} target='_blank' rel='noreferrer'>
                      <FontAwesomeIcon
                        icon={`fa-brands fa-mastodon`}
                        style={{ fontSize: 22, color: 'black' }}
                      />
                      <span style={{ display: 'none' }}>Mastodon link</span>
                    </a>
                  </li>
                )}
                {sponsor.url && (
                  <li className='mr-20'>
                    <a href={sponsor.url} target='_blank' rel='noreferrer'>
                      <FontAwesomeIcon
                        icon={'fa-solid fa-link'}
                        style={{ fontSize: 20, color: 'black' }}
                      />
                      <span style={{ display: 'none' }}>Website link</span>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Sponsor;

// export const Head = () => (
//     <Seo title="Sponsor" />
// );
